/**
 * Amendments Section Component
 *
 * Displays contract amendments for fully executed contracts.
 * Currently shows a placeholder - full amendment functionality
 * will be implemented in a future update.
 */

import { LwEmpty } from '@/components/lw';
import type { ContractInstanceData } from '@/types/recruitment';

interface AmendmentsSectionProps {
  candidateId?: string;
  contractInstance?: ContractInstanceData | null;
}

export const AmendmentsSection: React.FC<AmendmentsSectionProps> = () => {
  return (
    <div>
      <div className="dw-sec-title">Contract Amendments</div>
      <LwEmpty title="No amendments have been made to this contract.">
        Amendment functionality will be available in a future update.
      </LwEmpty>
    </div>
  );
};
